module.exports = __webpack_public_path__ + "img/time-circle-hover.f390459c.svg";